/* eslint-disable react-hooks/exhaustive-deps */
import { FC } from 'react';

export const EASSpinner: FC = () => {
	return (
		<div
			style={{
				display: 'flex',
				alignContent: 'center',
				justifyContent: 'center',
				height: '100vh',
				backgroundColor: '#f5f5f5',
				color: '#016193',
			}}
		>
			<div
				style={{
					height: '100vh',
					width: '100vw',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
				}}
			>
				<div style={{ height: '20vh' }}>
					<img src="/img/EAS-spinner.svg" alt="" style={{ height: '100%' }} />
				</div>
			</div>
		</div>
	);
};
